import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { set } from 'vue';
import { getProductPrice } from '~/utils/ProductPrice';
import CartProduct from '~/components/Layout/Cart/CartProduct.vue';
import { generateVariantString } from '~/utils';
import { useWait } from '~/composables/_next/useWait';
import { useLocalization } from '~/composables/_next/useLocalization';
import { isProductExpressDeliveryCompatible } from '~/utils/ProductAvailability';
import getImgByLabel from '@/utils/getImgByLabel';
export default defineComponent({
  components: {
    CartProduct: CartProduct
  },
  props: {
    isIngredients: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var _useLocalization = useLocalization(),
      country = _useLocalization.country,
      locale = _useLocalization.locale;
    var _useWait = useWait(),
      isWaiting = _useWait.isWaiting;
    var content = inject('content');
    var isStateEquipment = computed(function () {
      return content.state.value === 'equipments';
    });
    var close = function close() {
      emit('close');
    };
    var updateQty = function updateQty(product, quantity) {
      var _content$products$val, _content$products$val2;
      var qtys = (_content$products$val = content.products.value) === null || _content$products$val === void 0 ? void 0 : (_content$products$val2 = _content$products$val.filter(function (product) {
        return !product.outOfStock;
      })) === null || _content$products$val2 === void 0 ? void 0 : _content$products$val2.map(function (product) {
        return product.quantity;
      });
      var filteredQtys = qtys.filter(function (qty) {
        return qty >= 1;
      });
      if (filteredQtys.length === 1 && quantity === 0 && !isStateEquipment.value) return;
      set(product, 'baseQuantity', quantity);
      set(product, 'quantity', quantity);
    };
    onMounted(function () {
      if (isStateEquipment.value) {
        content.products.value.forEach(function (product) {
          set(product, 'quantity', 0);
        });
      }
    });
    function computeProductExpressDeliveryCompatible(product) {
      return isProductExpressDeliveryCompatible(product, country);
    }
    function computeProductPrice(product) {
      var price = getProductPrice(product).regular;
      var qty = product.quantity;
      if (qty === 0) {
        return price;
      }
      return price * qty;
    }
    return {
      products: content.products,
      selectedCapacity: content.selectedCapacity,
      quantity: content.quantity,
      getImgByLabel: getImgByLabel,
      generateVariantString: generateVariantString,
      locale: locale,
      close: close,
      updateQty: updateQty,
      computeProductExpressDeliveryCompatible: computeProductExpressDeliveryCompatible,
      computeProductPrice: computeProductPrice,
      isWaiting: isWaiting,
      getProductPrice: getProductPrice
    };
  }
});